import { render, staticRenderFns } from "./CellRendererTel.vue?vue&type=template&id=483f32a0&"
import script from "./CellRendererTel.vue?vue&type=script&lang=js&"
export * from "./CellRendererTel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports